
import React, { useState } from "react";
import { compose } from 'ramda';
import connect from 'react-redux/es/connect/connect';
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';
import { withContent } from '@synergycms_core/components/providers/translateProvider';
import styleFile from '../style';
import Form from '@synergycms_core/components/generic/Form';
import RichText from '@synergycms_core/components/generic/RichText';
import Button from '@synergycms_core/components/generic/Button';
import InputField from '@synergycms_core/components/generic/Form/InputField';
import ButtonSubmit from '@synergycms_core/components/generic/Form/ButtonSubmit';
import InputNotify from '@synergycms_core/components/generic/Form/InputNotify';
import actions from '../../../../../store/actions';
import {contextualizeAppConfig} from '@synergycms_core/store/app/utils';
//import { withTheme } from 'react-native-elements';
//import { useSelector, useDispatch } from 'react-redux';

const LoyaltyLogin = ({ theme: { styles: { classes }}, onView, login, hotelConfig, langCode, loyaltyType }) => {

  const forgot_password_url = hotelConfig.getIn(['fideltour','fildetour_forgot_password_url', langCode,'translatable_value'], "total");

  const [error, setError] = useState(false);

  //const hotelId = useSelector(state => state.getIn(['customer', 'current_hotel']));
  //const dispatch = useDispatch();

  const handleSubmit = (validForm, inputList) => {
    setError(false);

    if(!validForm) {
      return Promise.reject();
    }

    return login(inputList).then(() => {
      window.document.body.scrollTop = window.document.documentElement.scrollTop = 0;
    }).catch((e)=>{
      setError(e.message);
    });
  };
  
  return (
    <>
      <div className={classes.login}>
        <Form id="RegisterForm" disableLoading={true} onSubmit={handleSubmit}>
          <label className={classes.boxText} useref={'username'}>
            <InputField 
              model={'username'} innerStyle={['inputText', classes.inputText]}
              validationsFields={{ field: 'username' }}
              validations={['required', 'email']} 
            />
            <InputNotify model={'username'} />
            <RichText innerStyle={[classes.labelText, 'capitalize']} text={'_%email fidelizacion%_'} translate={true} />
          </label>
          <label className={classes.boxText} useref={'password'}>
            <InputField 
              model={'password'} type={'password'}
              innerStyle={['inputText', 'roboto16BlackModified', classes.inputText]}
              validationsFields={{ field: 'password' }}
              validations={['required', { type: 'maxLength', maxLength: 16 }, {
                type: 'minLength',
                minLength: 8
              }]} 
            />
            <InputNotify model={'password'} />
            <RichText 
              innerStyle={[classes.labelText, 'capitalize']} 
              text={'_%contrasena fidelizacion%_'}
              translate={true} 
            />
          </label>
          <ButtonSubmit richText={{ text: '_%login fidelizacion%_', translate: true, ucFirst: true }} innerStyle={[classes.uppercase, classes.fullWidth, 'toggleSecondButton']} />
          {error && <RichText innerStyle={[classes.errorText]} text={error} translate={true} />}
        </Form>

      </div>
      <div className={classes.textCenter}>
        {forgot_password_url &&
          <Button
            onClick={() => window.open(forgot_password_url, '_blank')}
            richText={{
              text: '_%recuperar contraseña%_',
              translate: true,
              ucFirst: true,
              innerStyle: ["blue", classes.underlineText, loyaltyType === 'fideltour' ? classes.forgotPasswordModified : ''],
            }}
            innerStyle={[classes.forgotPassword]}
          />}
          <RichText
            translate={true} ucFirst={true} innerStyle={['roboto14Gray300', classes.accountLogin]}
            text={'_%no cuenta fidelizacion%_'}
          />
      </div>
      <div className={classes.textCenter}>
        <Button
          onClick={() => onView('register')}
          richText={{ 
            text: '_%register fidelizacion%_', 
            translate: true, 
            ucFirst: true,
            innerStyle: [classes.registerText]
           }}
          innerStyle={[classes.uppercase, classes.buttonRegister, 'toggleSecondButton']}
        />
      </div>
    </>
  );
}

const mapDispatchToProps = dispatch => {
  return {
    login: (inputList) => {
      return dispatch(actions.customer.loyalty.login(inputList));
    }
  };
};

const mapStateToProps = (store) => {
  const hotelId = store.getIn(['customer', 'current_hotel']);

  return {
    langCode: store.getIn(['customer', 'lang_info', 'code']),
    hotelConfig :contextualizeAppConfig(store, hotelId),
    loyaltyType: store.getIn(['groupInfo', 'loyalty', 'code'], null),
  }
};

export default compose(connect(mapStateToProps, mapDispatchToProps), withThemeJSS({ styleFile,displayName:'style', }), withContent('i18n'))(LoyaltyLogin);